import {
  Button,
  ButtonCallNotes,
  ButtonGoBack,
  SelectableItem,
} from '../../Shared';

const PITCH_VARIANTS = [
  { label: 'Yes', value: 1, variant: 'primary' },
  { label: 'No', value: 0, variant: 'secondary' },
];

export const Pitch = ({
  pitchState,
  callNotes,
  onChangePitchState,
  handleOpenCallNotesModal,
  onChangeIndex,
  resetPitchState,
}) => {
  const isSecondQuestionVisible = pitchState.value.isPitchedProduct === 1;
  const isNextButtonDisabled =
    pitchState.value.isPitchedProduct === null ||
    (pitchState.value.isPitchedProduct === 1 &&
      pitchState.value.isSolutionPitchCompleted === null);

  return (
    <>
      <div className="flex flex-col gap-11 h-[386px] overflow-y-auto overflow-x-hidden rounded-[20px] bg-white/30 p-6 [&::-webkit-scrollbar-thumb]:bg-secondary/80 [&::-webkit-scrollbar-track]:bg-secondary/20 [&::-webkit-scrollbar]:w-2">
        <div className="flex flex-col gap-5">
          <p className="text-brand-900 font-semibold text-[18px]/[24px] text-center">
            Did you have a chance to pitch the product?
          </p>
          <div className="flex justify-center gap-3">
            {PITCH_VARIANTS.map(({ label, value, variant }) => (
              <SelectableItem
                key={value}
                label={label}
                selected={value === pitchState.value.isPitchedProduct}
                onClick={() => {
                  onChangePitchState(prev => ({
                    ...prev,
                    value: {
                      isPitchedProduct: value,
                      isSolutionPitchCompleted: null,
                    },
                  }));
                }}
                variant={variant}
              />
            ))}
          </div>
        </div>
        {isSecondQuestionVisible && (
          <div className="flex flex-col gap-5">
            <p className="text-brand-900 font-semibold text-[18px]/[24px] text-center">
              Were you able to complete your pitch of the solution?
            </p>
            <div className="flex justify-center gap-3">
              {PITCH_VARIANTS.map(({ label, value, variant }) => (
                <SelectableItem
                  key={value}
                  label={label}
                  selected={value === pitchState.value.isSolutionPitchCompleted}
                  onClick={() => {
                    onChangePitchState(prev => ({
                      ...prev,
                      value: {
                        ...prev.value,
                        isSolutionPitchCompleted: value,
                      },
                    }));
                  }}
                  variant={variant}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="flex items-center justify-between rounded-[20px] bg-white/30 px-6 py-5">
        <ButtonGoBack
          onClick={() => {
            onChangeIndex(1);
            resetPitchState();
          }}
        />
        <Button
          title="Next"
          onClick={() => {
            onChangePitchState(prev => ({ ...prev, visible: false }));
          }}
          disabled={isNextButtonDisabled}
        />
        <ButtonCallNotes
          onClick={handleOpenCallNotesModal}
          hasBg={callNotes && callNotes !== 'null'}
        />
      </div>
    </>
  );
};
